import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/mobile-menu.svg'
import _imports_1 from '@/assets/img/mobile-header.svg'


const _hoisted_1 = { class: "main-header" }
const _hoisted_2 = { class: "main-header__wrapper" }
const _hoisted_3 = { class: "main-header__actions" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "main-header__logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)
const _hoisted_7 = { class: "main-header__actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "main-header__item",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showHeader()))
        }, _hoisted_5)
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: "main-header__lang",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.SwitchLang()))
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("main.langMobile")), 1)
        ])
      ])
    ])
  ]))
}